import { $qs, $qsa } from './utils/querySelector';
import { media } from './utils/mediaQueries';
import { gsap } from 'gsap';



class Menu {
    constructor(trigger) {
        this.trigger = trigger;
        this.isOpen = false;
        this.isAnimating = false;

        this.init();
        // this.initScrollHandler();
    }

    init() {
        this.body = $qs('body');
        this.menu = $qs('[data-target="main-menu"]');
        this.menuPrimary = $qs('[data-target="menu-primary"]');
        this.menuBackground = $qs('[data-target="menu-background"]');
        this.triggerParent = this.trigger.closest('.menu-trigger');
        this.secondaryMenuTriggers = $qsa('[data-target="menu-secondary-menu-trigger"]');
        this.secondaryMenuBackButtons = $qsa('[data-target="menu-secondary-back-button"]');
        // this.menuContainer = $qs('[data-target="menu-container"]');
        // this.menuItems = $qsa('[data-target="menu-items"] > li');
        this.topLevelParents = $qsa('#main-menu > li.menu-item-has-children > a');
        // this.subMenuCloseButtons = $qsa('[data-target="sub-menu-close"]');
        // this.menuTriggerHamburgerLines = $qsa('[data-target="menu-trigger-hamburger"] > div');
        
        if (!this.menu) return;
        
        this.trigger.addEventListener('click', this.toggleMenu.bind(this), false);

        this.secondaryMenuTriggers.forEach(secondaryMenuTrigger => secondaryMenuTrigger.addEventListener('click', (e) => {
            this.closeAllSecondaryMenus();
            this.toggleSecondaryMenu(secondaryMenuTrigger, e);
        }, false));

        this.secondaryMenuBackButtons.forEach(secondaryMenuBackButton => secondaryMenuBackButton.addEventListener('click', (e) => {
            this.closeAllSecondaryMenus();
            this.setTriggerColor('#CA333A');
            this.setTriggerHamburgerColor('#FFF');
        }, false));

        this.topLevelParents.forEach(topLevelParent => topLevelParent.addEventListener('click', (e) => {
            if (!media.xl) {
                this.closeAllSubMenus(e);
                this.openSubMenu(topLevelParent, e);
            }
        }, false));

        // this.subMenuCloseButtons.forEach(subMenuCloseButton => subMenuCloseButton.addEventListener('click', (e) => {
        //     this.closeAllSubMenus(e);
        // }, false));

        // this.menuBackdrop.addEventListener('click', this.closeMenu.bind(this), false);
    }

    initScrollHandler() {
        window.addEventListener('scroll', () => {
            const scrollPosition = window.scrollY;
            const viewportHeight = window.innerHeight;

            if (scrollPosition > viewportHeight && !this.isOpen) {
                if (media.sm) {
                    this.triggerParent.style.setProperty('--trigger-main-color', 'rgba(0, 0, 0, 0.5)');
                } else {
                    this.triggerParent.style.setProperty('--trigger-main-color', 'rgba(0, 0, 0, 0.5)');
                }
            } else if (!this.isOpen && document.body.classList.contains('page-template-tpl-home-2025')) {
                if (media.sm) {
                    this.triggerParent.style.setProperty('--trigger-main-color', 'transparent');
                } else {
                    this.triggerParent.style.setProperty('--trigger-main-color', '#FFF');
                }
            }
        });
    }

    setTriggerColor(color) {
        this.triggerParent.style.setProperty('--trigger-main-color', color);
    }

    setTriggerHamburgerColor(color) {
        this.triggerParent.style.setProperty('--trigger-hamburger-color', color);
    }

    setTriggerBackground(color) {
        this.triggerParent.style.setProperty('--trigger-background', color);
    }

    openMenu() {
        const timeline = gsap.timeline({
            onStart: () => {
                this.isAnimating = true;
                this.isOpen = true;

                this.setTriggerColor('#CA333A');
                this.setTriggerHamburgerColor('#FFF');
                this.setTriggerBackground('transparent');

                this.body.style.overflow = 'hidden';
                this.trigger.dataset.state = 'open';
            },
            onComplete: () => {
                this.isAnimating = false;
            }
        });

        if (this.isAnimating) return;

        timeline
            .addLabel('start')
            .to(this.menuBackground, {
                opacity: 1,
                duration: 0.5,
                ease: 'power3.inOut',
            }, 'start')
            .to(this.menuPrimary, {
                y: '0%',
                duration: 0.5,
                ease: 'power3.inOut',
            }, 'start')

        // const currentAncestor = [...this.topLevelParents].find(item => item.closest('li').classList.contains('current-menu-ancestor'));

        // if (currentAncestor) {
        //     currentAncestor.click();
        // }
    }

    closeMenu() {
        const timeline = gsap.timeline({
            onStart: () => {
                this.isAnimating = true;
                this.isOpen = false;

                this.setTriggerColor('#FFF');
                this.setTriggerHamburgerColor('#CA333A');
                this.setTriggerBackground('rgba(0, 0, 0, 0.5)');

                this.body.style.overflow = 'visible';
                this.trigger.dataset.state = 'closed';

            },
            onComplete: () => {
                this.isAnimating = false;
            }
        });

        timeline
            .addLabel('start')
            .to(this.menuBackground, {
                opacity: 0,
                duration: 0.5,
                ease: 'power3.inOut',
            }, 'start')
            .to(this.menuPrimary, {
                y: '-100%',
                duration: 0.5,
                ease: 'power3.inOut',
            }, 'start')
    }

    toggleMenu() {
        if (this.isAnimating) return;

        if (this.isOpen) {
            this.closeAllSecondaryMenus();
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openSecondaryMenu(clickedElement, e) {
        e.preventDefault();

        const secondaryMenu = $qs(`[data-target="menu-secondary-menu"][data-menu="${clickedElement.dataset.menu}"]`);

        const timeline = gsap.timeline({
            onStart: () => {
                this.setTriggerColor('#FFF');
                this.setTriggerHamburgerColor('#CA333A');
            }
        });

        timeline
            .addLabel('start')
            .to(secondaryMenu, {
                y: '0%',
                duration: 0.5,
                ease: 'power3.inOut',
            }, 'start')
        
    }

    closeSecondaryMenu(clickedElement, e) {
        e.preventDefault();

        const secondaryMenu = $qs(`[data-target="menu-secondary-menu"][data-menu="${clickedElement.dataset.menu}"]`);

        const timeline = gsap.timeline({
            onStart: () => {
                this.setTriggerColor('#CA333A');
                this.setTriggerHamburgerColor('#FFF');
            }
        });

        timeline
            .addLabel('start')
            .to(secondaryMenu, {
                y: '-100%',
                duration: 0.5,
                ease: 'power3.inOut',
            }, 'start')
    }

    closeAllSecondaryMenus() {
        const secondaryMenus = $qsa('[data-target="menu-secondary-menu"]');
        const timeline = gsap.timeline();
        
        timeline
            .addLabel('start')
            .to(secondaryMenus, {
                y: '-100%',
                duration: 0.5,
                ease: 'power3.inOut',
            }, 'start');
    }

    toggleSecondaryMenu(clickedElement, e) {
        e.preventDefault();

        if (clickedElement.dataset.state === 'closed') {
            this.openSecondaryMenu(clickedElement, e);
        } else {
            this.closeSecondaryMenu(clickedElement, e);
        }
    }

    openSubMenu(clickedElement, e) {
        e.preventDefault();

        const subMenu = $qs('ul.sub-menu', clickedElement.closest('li'));
        let { state } = subMenu.dataset;

        if (!state) {
            state = 'closed';
            subMenu.dataset.state = 'closed';
        }

        const timeline = gsap.timeline({
            onStart: () => {
                subMenu.dataset.state = state === 'closed' ? 'open' : 'closed';
            }
        });

        timeline
            .addLabel('start')
            .to(subMenu, {
                height: state === 'closed' ? 'auto' : '0',
                duration: 0.3,
                ease: 'power3.inOut',
            }, 'start')
    }

    closeAllSubMenus(e) {
        e.preventDefault();

        const subMenus = $qsa('ul.sub-menu');
        const timeline = gsap.timeline({
            onStart: () => {
                subMenus.forEach(subMenu => {
                    subMenu.dataset.state = 'closed';
                });
            }
        });

        timeline
            .addLabel('start')
            .to(subMenus, {
                height: 0,
                duration: 0.3,
                ease: 'power3.inOut',
            }, 'start')
    }
}

const menuTrigger = $qs('[data-target="menu-trigger"]');

if (menuTrigger) {
    const menu = new Menu(menuTrigger);
}